module.exports = __webpack_public_path__ + "assets/img/8028-bl.svg";